/*
  *redunx-常量
  bill_yang 2021.06
*/
export const DEMO = 'demo';

export const TOGGLE_COUPON = 'TOGGLE_COUPON';
